import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fireFilled"
const FireFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.053 1.707C12.535 1.576 13.075 1.52 13.47 1.88 13.654 2.05 13.747 2.261 13.8 2.444 13.853 2.624 13.88 2.822 13.898 3.005 13.975 3.761 13.978 4.685 14.566 5.723 14.846 6.217 15.23 6.597 15.7 6.988 16.149 7.361 16.737 7.79 17.258 8.291 18.37 9.363 19.316 10.874 19.512 13.801 19.803 18.138 16.243 22.311 11.656 22.312 7.071 22.312 3.492 18.144 3.765 13.803 3.858 12.324 3.977 11.414 4.145 10.915 4.189 10.784 4.245 10.652 4.325 10.538 4.402 10.424 4.53 10.288 4.726 10.22 5.153 10.078 5.47 10.374 5.57 10.475 5.707 10.613 5.834 10.799 5.937 10.955 6.052 11.127 6.151 11.284 6.261 11.437Q6.424 11.667 6.54 11.769 6.576 11.796 6.594 11.805H6.598Q6.62 11.794 6.655 11.757C6.697 11.708 6.736 11.624 6.732 11.507 6.645 9.149 7.267 6.91 8.246 5.165 9.215 3.437 10.585 2.107 12.053 1.707M11.343 11.989C11.16 12.003 11.008 12.142 10.969 12.323 10.822 13.003 11.168 13.938 10.326 15.375 9.73 16.395 8.826 16.844 8.826 18.75 8.826 20.465 10.452 21 11.451 21 13.714 21 14.451 19.875 14.451 18.518 14.451 17.78 14.41 16.457 13.651 14.44 13.286 13.463 12.372 11.911 11.345 11.99"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FireFilledIcon
